import { useSnackbar } from 'notistack';
import { QuoteResolver } from 'quote-detail/quote-resolver';
import { Redirect, useParams } from 'react-router-dom';
import { ROUTES } from 'routing/routes';
import { ProvideQuoteState } from 'shared/contexts';
import { useBrandRedirect } from 'shared/hooks';
import { useAuthState } from 'shared/stores';
import { Brands } from 'shared/types';

export function QuoteDetailResolver() {
  const { brand, id } = useParams<{ brand: Brands; id: string }>();
  const authState = useAuthState();
  const user = authState.user.get();

  const [redirect] = useBrandRedirect(user?.insightClaims || '', sites => !sites.includes(brand));
  const { enqueueSnackbar } = useSnackbar();

  if (!user) {
    return null;
  }

  if (redirect) {
    enqueueSnackbar(`You are not allowed to view the quotes for this brand: ${brand}`, { variant: 'error' });
    return <Redirect to={ROUTES.brands} />;
  }

  return (
    <ProvideQuoteState>
      <QuoteResolver user={user} id={id} brand={brand} />
    </ProvideQuoteState>
  );
}
